<div class="menu-container">
    <div class="back">
        <button class="dotted-arrow" mat-icon-button (click)="onCloseSiteMenu()">←</button>
    </div>

    <div class="menu">
        <div *ngIf="isLoggedIn$ | async" class="search">
            <form class="searchbar" [formGroup]="form" (ngSubmit)="submitSearch()">
                <div fxLayout fxLayoutAlign="flex-start" class="searchbar">
                    <button class="submitButton">
                        <mat-icon class="search-icon" svgIcon="hering-search"></mat-icon>
                    </button>

                    <input formControlName="searchText" type="text" placeholder="Search..."/>
                </div>
            </form>
        </div>

        <ng-container *ngIf="!(isLoggedIn$ | async)" >
            <a *ngIf="this.isLoginPageShown()" class="active menu-item" i18n="@@site-menu_entry-login">Login</a>
            <a *ngIf="!isLoginPageShown()" class="menu-item" (click)="onCloseSiteMenu()" routerLink="/login"
               i18n="@@site-menu_entry-login">Login</a>
        </ng-container>

        <ng-container *ngIf="isLoggedIn$ | async" >
            <a *ngIf="isCategoriesPageShown()" class="menu-item active" i18n="@@site-menu_entry-home">Home</a>
            <a *ngIf="!isCategoriesPageShown()" class="menu-item" (click)="onCloseSiteMenu()" routerLink="/home"
               i18n="@@site-menu_entry-home">Home</a>
        </ng-container>

        <ng-container *ngIf="isLoggedIn$ | async">
            <a *ngIf="isProductCollectionPageShown()" class="menu-item active" i18n="@@site-menu_entry-catalog">Catalog</a>
            <a *ngIf="!isProductCollectionPageShown()" class="menu-item" (click)="onCloseSiteMenu()"
               routerLink="/products" i18n="@@site-menu_entry-catalog">Catalog</a>
        </ng-container>

        <ng-container *ngIf="isLoggedIn$ | async">
            <a *ngIf="isDownloadShown()" class="menu-item active" i18n="@@site-menu_entry-downloads">Downloads</a>
            <a *ngIf="!isDownloadShown()" class="menu-item" (click)="onCloseSiteMenu()"
               routerLink="/download" i18n="@@site-menu_entry-downloads">Downloads</a>
        </ng-container>

        <ng-container *ngIf="isLoggedIn$ | async">
            <a *ngIf="isContactPageShown()" class="menu-item active" i18n="@@site-menu_entry-contact">Contact</a>
            <a *ngIf="!isContactPageShown()" class="menu-item" (click)="onCloseSiteMenu()" routerLink="/contact"
               i18n="@@site-menu_entry-contact">Contact</a>
        </ng-container>

        <ng-container>
            <a class="menu-item" [href]="getB2cShopLink()" i18n="@@site-menu_b2c-button">B2C</a>
        </ng-container>
    </div>

    <app-site-menu-footer
        (closeSiteMenu)="onCloseSiteMenu()"
        [isLoggedIn]="isLoggedIn$ | async"
        [languages]="languages"
        [currentLanguage]="currentLanguage"
        (loggedOut)="logout()"
        (languageSwitched)="switchLanguage($event)"
    ></app-site-menu-footer>
</div>

